import { useQuery } from '@apollo/client';

import { GET_ME } from '../queries/getMe';

/**
 * Who gets the "Create class" page.
 *
 * **Reads the server's own answer** (`Membership.canCreateCourse`). This was `isAdmin` — the
 * ADMIN role — while the mutation behind the page asked for `ADMINISTER_ORGANISATION_DATA`.
 * Those are different questions, and the menu was the stricter of the two: somebody could hold
 * everything the save needed and still never be shown the page.
 *
 * The same construction as `useCanCreatePerson` and `useCanAccessLeadership`, for the same
 * reason — which roles carry `CREATE_COURSE` is data edited on `/admin/roles`, so any list of
 * role names kept on this side is a copy that goes stale without saying so.
 */
export const useCanCreateCourse = () => {
  const [result] = useCanCreateCourseLoading();

  return result;
};

/**
 * The same answer with the loading flag, for the page itself.
 *
 * A menu entry can treat "not loaded yet" as "no" and simply appear a moment later. A *page*
 * cannot: redirecting on the un-loaded value bounces somebody off a page they are allowed to
 * see, before the server has been asked. Same split as `useCanCreatePersonLoading`.
 */
export const useCanCreateCourseLoading = (): [boolean, boolean] => {
  const { data, loading, error } = useQuery(GET_ME);

  return [!loading && !error && !!data?.me?.organisation?.membership?.canCreateCourse, loading];
};
